import React from 'react';
import { IconFilter } from '@noths/polaris-client-ribbons-design-system';

import { NumericalLozenge } from 'src/components/atoms/NumericalLozenge/NumericalLozenge';
import * as styles from 'src/components/organisms/ListingsHeader/ListingsHeader.styles';

export interface ListingsHeaderProps {
  onButtonClick: () => void;
  totalActiveFacetOptions: number;
  totalProducts: number;
}

export const ListingsHeader = ({
  onButtonClick,
  totalActiveFacetOptions,
  totalProducts,
}: ListingsHeaderProps) => {
  const accessibleFilterLabel = `Filter options (${totalActiveFacetOptions} selected)`;

  return (
    <div css={styles.listingsHeaderRoot}>
      <p css={styles.totalProducts}>Showing {totalProducts} products</p>
      <button
        aria-label={accessibleFilterLabel}
        css={styles.listingsHeaderButton}
        onClick={onButtonClick}
        type="button"
      >
        {totalActiveFacetOptions > 0 && (
          <NumericalLozenge
            value={totalActiveFacetOptions > 99 ? '99+' : `${totalActiveFacetOptions}`}
          />
        )}
        Filter & Sort
        <IconFilter
          className="iconFilter"
          color="var(--neutral-white-base)"
          css={styles.iconFilter}
        />
      </button>
    </div>
  );
};
